RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _, moment, CompareData) {

    'use strict';

    const Sources = RivalIQ.enums.sources;

    const channelConnectionTemplates = {};
    channelConnectionTemplates[Sources.FACEBOOK] = '#reconnectAccountConnectionTemplate';
    channelConnectionTemplates[Sources.LINKEDIN] = '#reconnectAccountConnectionTemplate';

    function getChannelConnectionTemplate(channel) {
        const source = CompareData.getSource(channel);

        if (RivalIQ.enums.sourceDetails[source].multiOauthToken) {
            return '#multiTokenAccountConnectionTemplate';
        }
        const channelConnectionTemplate = channelConnectionTemplates[source];
        return channelConnectionTemplate;
    }

    views.AccountConnections = RivalIQ.views.CompositeView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        template: '#accountConnectionsTemplate',
        initialize: function () {
            const me = this;
            me.collection = RivalIQ.data.channels.withAuthorization().supportedOnly();
        },
        childView: views.AccountConnectionItem,
        childViewContainer: '.x-account-connections',
        childViewOptions: function (model) {
            const me = this;

            const options = {};
            const channel = model.get('channel');
            // HACK HACK
            // FIXME: this should useMaxTokenName, but only twitter has been setup yet
            // const maxTokenName = `${channel}_max_tokens`;
            const maxTokenName = `twitter_max_tokens`;
            model.set('maxMultiTokens', RivalIQ.state.account.get('plan')[maxTokenName]);

            const channelConnectionTemplate = getChannelConnectionTemplate(channel);

            if (channelConnectionTemplate) {

                options.template = channelConnectionTemplate;
            }

            options.curation = me.dashboardModel.curation;

            return options;
        }
    });

}, window.moment, RivalIQ.data.CompareData);
